import axios from 'axios';

export default {
  namespaced: true,
  state: {
    teams: [],
    endpoint: '/rb_users_teams.json',
    errors: [],
    loaded: false
  },

  getters: {
    filter: (state) => search => {
      return state.teams.filter(team => (team.name.toLowerCase().indexOf(search.toLowerCase()) >= 0) || team.team_name.toLowerCase().indexOf(search.toLowerCase()) >= 0);
    }
  },

  mutations: {
    setTeams(state, teams) {
      state.teams = teams;
    },

    setEndPoint(state, endpoint) {
      state.endpoint = endpoint;
    },

    addError(state, error) {
      state.errors.push(error);
    }
  },

  actions: {
    fetch({state, commit}) {
      axios.get(state.endpoint)
        .then(function (response) {
          state.loaded = true;
          commit('setTeams', response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
};
